import { useCallback, useEffect } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { TIME_OUT_STATUS, STATUS_START_DELAY } from "@constants"
import { adminIdStatusReportList, globalExecutionsTableReportCellData, tableReportData } from "../../@signals"
import { useReportBackendApiPath } from "Pages/Admin/GlobalExecution/Reports/@hooks/index"

export default function useManageAdminStatusMultiple() {
	const { multipleStatus } = useReportBackendApiPath()

	const getStatus = useCallback(() => {
		let isMounted = true

		const fetchStatus = () => {
			if (document.hidden) {
				// a background tab keeps its timer but sends nothing; it catches up when shown again
				setTimeout(() => {
					if (isMounted) fetchStatus()
				}, TIME_OUT_STATUS)
				return
			}
			if (adminIdStatusReportList.value.length) {
				postSubmit(multipleStatus, {
					executions: adminIdStatusReportList.value.map(idReport => (idReport))
				}).then((res) => {
					if (!isMounted) return
					const filteredIds = Object.values(res)
						.filter(item => !item?.ExecutionGlobalStatusCompleted)
						.map(item => item?.idReportExecution)
					if (filteredIds.length !== adminIdStatusReportList.value.length) {
						adminIdStatusReportList.value = filteredIds
						tableReportData.value = tableReportData.value.filter(({ id_last_execution }) => filteredIds.includes(id_last_execution))
					}

					globalExecutionsTableReportCellData.value = {
						...globalExecutionsTableReportCellData.value,
						...res
					}

					if (Object.keys(res).some(key => !res[key].ExecutionGlobalStatusComplete)) {
						setTimeout(() => {
							if (isMounted) fetchStatus()
						}, TIME_OUT_STATUS)
					}
				})
			}
		}

		fetchStatus()

		return () => {
			isMounted = false
		}
	}, [adminIdStatusReportList.value.length])

	useEffect(() => {
		// getStatus is recreated for every row that registers on mount: without the delay each one
		// restarted the poll and fired a POST, N of them for N running rows
		let stop
		const timer = setTimeout(() => { stop = getStatus() }, STATUS_START_DELAY)
		return () => {
			clearTimeout(timer)
			if (stop) stop()
		}
	}, [getStatus])

}
